<template>
  <div class="introduction">
    <mds-layout-grid>
      <mds-row>
        <mds-col>
          <div class="product-introduction-title">The Problem</div>
          <div class="center-align">
            <span class="normal-text"> Existing feeds can be </span>
            <span class="bold-text"> complicated, incomplete and expensive. </span>
            <span class="normal-text"> Keeping on top of your </span>
          </div>
          <div class="center-align">
            <span class="normal-text"> CMBS investments with inaccurate data puts your portfolios at risk. </span>
          </div>
        </mds-col>
      </mds-row>
    </mds-layout-grid>
  </div>
</template>

<script>

export default {
  name: "Introduction",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.introduction {
  top: 442px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: calc(#{$mds-space-8-x} + #{$mds-space-three-quarter-x});
  margin-bottom: calc(#{$mds-space-8-x} + #{$mds-space-three-quarter-x});
  @include mds-level-3-heading()
}
.product-introduction-title {
  font-weight: 700;
  line-height: 34px;
  text-align: center;
  font-size: 32px;
  letter-spacing: 0.01em;
  margin-bottom: 20px;
}
.center-align {
  text-align: center;
}
.bold-text {
  font-weight: 700;
  font-size: 28px;
  line-height: 42px;
  }
.normal-text {
  font-weight: 300;
  font-size: 28px;
  line-height: 42px;
}
</style>
